export default Object.freeze({
  ADMIN_AUTH_URL: `${process.env.API_URL_FOR_FRONT}/api/v1/admin_auth`,
  ADMIN_API_URL: `${process.env.API_URL_FOR_FRONT}/api/v1/admin`,
  PARTNER_AUTH_URL: `${process.env.API_URL_FOR_FRONT}/api/v1/partner_auth`,
  SHOPPING_API_URL: `${process.env.API_URL_FOR_FRONT}/api/v1/shopping`,
  SHOPING_FRONT_URL: `${process.env.FRONT_URL}/shopping/shopping_orders`,
  IMAGE_SKIP_VALUE: 'N/A',
  SELECTBOX_NOT_SELECTED: {
    text: '（全て）',
    value: -1,
  },
  SHOPS_BY_PREFECTURE: [
    {
      code: '1',
      name: '北海道',
      shops: [],
    },
    {
      code: '2',
      name: '青森県',
      shops: [],
    },
    {
      code: '3',
      name: '岩手県',
      shops: [],
    },
    {
      code: '4',
      name: '宮城県',
      shops: [],
    },
    {
      code: '5',
      name: '秋田県',
      shops: [],
    },
    {
      code: '6',
      name: '山形県',
      shops: [],
    },
    {
      code: '7',
      name: '福島県',
      shops: [],
    },
    {
      code: '8',
      name: '茨城県',
      shops: [],
    },
    {
      code: '9',
      name: '栃木県',
      shops: [],
    },
    {
      code: '10',
      name: '群馬県',
      shops: [],
    },
    {
      code: '11',
      name: '埼玉県',
      shops: [],
    },
    {
      code: '12',
      name: '千葉県',
      shops: [],
    },
    {
      code: '13',
      name: '東京都',
      shops: [],
    },
    {
      code: '14',
      name: '神奈川県',
      shops: [],
    },
    {
      code: '15',
      name: '新潟県',
      shops: [],
    },
    {
      code: '16',
      name: '富山県',
      shops: [],
    },
    {
      code: '17',
      name: '石川県',
      shops: [],
    },
    {
      code: '18',
      name: '福井県',
      shops: [],
    },
    {
      code: '19',
      name: '山梨県',
      shops: [],
    },
    {
      code: '20',
      name: '長野県',
      shops: [],
    },
    {
      code: '21',
      name: '岐阜県',
      shops: [],
    },
    {
      code: '22',
      name: '静岡県',
      shops: [],
    },
    {
      code: '23',
      name: '愛知県',
      shops: [],
    },
    {
      code: '24',
      name: '三重県',
      shops: [],
    },
    {
      code: '25',
      name: '滋賀県',
      shops: [],
    },
    {
      code: '26',
      name: '京都府',
      shops: [],
    },
    {
      code: '27',
      name: '大阪府',
      shops: [],
    },
    {
      code: '28',
      name: '兵庫県',
      shops: [],
    },
    {
      code: '29',
      name: '奈良県',
      shops: [],
    },
    {
      code: '30',
      name: '和歌山県',
      shops: [],
    },
    {
      code: '31',
      name: '鳥取県',
      shops: [],
    },
    {
      code: '32',
      name: '島根県',
      shops: [],
    },
    {
      code: '33',
      name: '岡山県',
      shops: [],
    },
    {
      code: '34',
      name: '広島県',
      shops: [],
    },
    {
      code: '35',
      name: '山口県',
      shops: [],
    },
    {
      code: '36',
      name: '徳島県',
      shops: [],
    },
    {
      code: '37',
      name: '香川県',
      shops: [],
    },
    {
      code: '38',
      name: '愛媛県',
      shops: [],
    },
    {
      code: '39',
      name: '高知県',
      shops: [],
    },
    {
      code: '40',
      name: '福岡県',
      shops: [],
    },
    {
      code: '41',
      name: '佐賀県',
      shops: [],
    },
    {
      code: '42',
      name: '長崎県',
      shops: [],
    },
    {
      code: '43',
      name: '熊本県',
      shops: [],
    },
    {
      code: '44',
      name: '大分県',
      shops: [],
    },
    {
      code: '45',
      name: '宮崎県',
      shops: [],
    },
    {
      code: '46',
      name: '鹿児島県',
      shops: [],
    },
    {
      code: '47',
      name: '沖縄県',
      shops: [],
    },
    {
      code: '48',
      name: '海外',
      shops: [],
    },
    {
      code: '49',
      name: 'その他',
      shops: [],
    },
  ],
});
